export default __webpack_public_path__ + "static/media/pagekite.cfcc73f5.svg";